import { createContext, useContext, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

const ConsentContext = createContext();
export const useConsent = () => useContext(ConsentContext);

const KEY = "pl_cookie_consent";

export function ConsentProvider({ children }) {
  const [consent, setConsent] = useState(() => localStorage.getItem(KEY));
  const { t } = useLang();

  const decide = (v) => {
    localStorage.setItem(KEY, v);
    setConsent(v);
  };

  const reset = () => {
    localStorage.removeItem(KEY);
    setConsent(null);
  };

  return (
    <ConsentContext.Provider value={{ consent, decide, reset }}>
      {children}
      <AnimatePresence>
        {!consent && (
          <motion.div className="fixed bottom-0 inset-x-0 z-[110] bg-charcoal text-ivory px-6 py-5 lg:py-6"
            initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            data-testid="cookie-banner">
            <div className="max-w-[1440px] mx-auto flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
              <p className="text-sm text-ivory/80 leading-relaxed max-w-2xl">
                {t("privacy.bannerText")}{" "}
                <Link to="/cookie-policy" className="underline underline-offset-2 hover:text-gold" data-testid="cookie-banner-policy-link">{t("privacy.navCookies")}</Link>
                {" · "}
                <Link to="/privacy" className="underline underline-offset-2 hover:text-gold" data-testid="cookie-banner-privacy-link">{t("privacy.navPrivacy")}</Link>
              </p>
              <div className="flex gap-3 shrink-0">
                <button onClick={() => decide("rejected")} data-testid="cookie-reject"
                  className="text-[11px] tracking-[0.18em] uppercase border border-ivory/30 px-5 py-2.5 rounded-full hover:border-ivory transition-colors">
                  {t("privacy.reject")}
                </button>
                <button onClick={() => decide("accepted")} data-testid="cookie-accept"
                  className="text-[11px] tracking-[0.18em] uppercase bg-ivory text-charcoal px-5 py-2.5 rounded-full hover:bg-gold transition-colors">
                  {t("privacy.accept")}
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </ConsentContext.Provider>
  );
}
